import { render } from "./WasteCarsList.vue?vue&type=template&id=90d1d490&scoped=true"
import script from "./WasteCarsList.vue?vue&type=script&lang=js"
export * from "./WasteCarsList.vue?vue&type=script&lang=js"

import "./WasteCarsList.vue?vue&type=style&index=0&id=90d1d490&scoped=true&lang=css"

import exportComponent from "/home/le01s/projects/amlogger/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d1d490"]])

export default __exports__